import { useState } from "react";
import ContentComponent from "./content";

function Content({ onClick }) {
  const [selectedSubMenu, setSelectedSubMenu] = useState(undefined);

  const handleSelectManeuItem = (id) => () => {
    setSelectedSubMenu(id);
    if (!id) {
      onClick();
    }
  };

  return (
    <ContentComponent
      selectedSubMenu={selectedSubMenu}
      onSelectManeuItem={handleSelectManeuItem}
    />
  );
}

export default Content;
